<template>
  <div class="page" :class="{ 'error': !(payData && payData.payReceivablesAppPaymentFormDtoAList && payData.payReceivablesAppPaymentFormDtoAList.length > 0)}">
    <div class="page-content">
      <div class="page-list" v-if="payData && payData.payReceivablesAppPaymentFormDtoAList && payData.payReceivablesAppPaymentFormDtoAList.length > 0">
        <div class="item" v-for="(info, i) in payData.payReceivablesAppPaymentFormDtoAList" :key="i">
          <div class="item-header">
            <div class="item-header-left">
              <img class="item-header-left-icon" :src="getPageType.icon" alt="">
              <span class="item-header-left-text">{{ info.fareTypeName }}</span>
            </div>
            <div class="item-header-right">
              <span class="item-header-right-text">￥{{ info.qjNmny }}</span>
            </div>
          </div>
          <div class="item-content">
            <div class="item-content-left">
              <div class="item-content-left-row">
                <span class="item-content-left-row-text">应收金额: ¥{{info.nmny || '0' }} </span>
              </div>
              <div class="item-content-left-row">
                <span class="item-content-left-row-text">已缴金额: ¥{{info.nrevmny || '0' }}</span>
              </div>
              <div class="item-content-left-row">
                <span class="item-content-left-row-text">账单年月：{{ info.ymonth }}</span>
              </div>
              <div class="item-content-left-row">
                <span class="item-content-left-row-text">房间：{{info.buildingName}}{{info.unitName}}{{info.housename}}</span>
              </div>
            </div>
            <span :class="['item-content-right', (info.paymentstatus === '0' || info.paymentstatus === '3') ? 'color-orange' : 'color-green']">
              {{ info.paymentstatusStr }}
            </span>
          </div>
        </div>
      </div>
      <div v-else-if="status === 1" class="page-error">
        此账单已结清
      </div>
      <div v-else class="page-error">
        账单状态存在异常，请联系管理员
      </div>
    </div>
    <div class="page-footer" v-if="payData && payData.payReceivablesAppPaymentFormDtoAList && payData.payReceivablesAppPaymentFormDtoAList.length > 0">
      <div class="page-footer-top">
        <div class="page-footer-top-left">
          <div class="paid-item">应收金额: ￥{{ payData.nmny || 0 }}</div>
          <div class="paid-item">本次收款金额: ￥{{ payData.qjNmny || 0 }}</div>
        </div>
        <div class="page-footer-top-right">
          <span class="page-footer-top-right-text" @click="handlePay">确认缴费</span>
        </div>
      </div>
      <!-- <div class="page-footer-paytype">
        <span class="page-footer-paytype-text">支付方式: </span>
        <div class="pay-list">
          <div class="item active" v-for="(item, index) in payListData" :key="index">
            <img class="item-icon" :src="item.icon" mode="widthFix" />
            <span class="item-label">{{item.label}}</span>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { NetService } from '@/service'
import { Toast } from 'vant'
export default {
  data () {
    return {
      status: 0,
      type: 1,
      payData: {},
      payValue: 0,
      // payListData: [],
      // payList: [],
      receivables: [],
      orderId: '',
      openId: ''
    }
  },
  computed: {
    getPageType() {
      let res
      switch (this.type){
        case '1':
          res = {
            icon: 'https://oss-public.uopgenjoy.com/prod/static/property/images/icons/icon-water-02.png',
            name: '水电费',
          }
          break;
        case '2':
          res = {
            icon: 'https://oss-public.uopgenjoy.com/prod/static/property/images/icons/icon-list-03.png',
            name: '有偿维修工费',
          }
          break;
        default:
        case '3':
          res = { 
            icon: 'https://oss-public.uopgenjoy.com/prod/static/property/images/icons/icon-home-02.png',
            name: '物业费' 
          }
          break;
      }
      return res
    }
  },
  mounted() {
    // this.getUserAgent()
    if (this.$route.query && this.$route.query.receivables) {
      this.receivables = this.$route.query.receivables.split(',')
      this.getList()
    }
  },
  methods: {
    // getUserAgent() {
    //   const userAgent = navigator.userAgent.toLowerCase()
    //   if(userAgent.match(/Alipay/i) == "alipay") {
    //     this.payList.push({ label: '支付宝支付', icon: require('@/assets/image/icon-alipay-01.png'), value: 'ALIPAY' })
    //     this.payListData.push({ label: '支付宝', icon: 'https://oss-public.uopgenjoy.com/prod/static/property/images/icons/icon-alipay-03.png', value: 5 })
    //   } else if(userAgent.match(/MicroMessenger/i) == "micromessenger") {
    //     this.payList.push({ label: '微信支付', icon: require('@/assets/image/icon-wechat-01.png'), value: 'WECHAT' })
    //     this.payListData.push({ label: '微信', icon: 'https://oss-public.uopgenjoy.com/prod/static/property/images/icons/icon-wechat-03.png', value: 4 })
    //   }
    // },
    getList() {
      try {
        let loading = Toast.loading({ duration: 0, message: '加载中...' })
        NetService.accountsReceivableAppPaymentForm(this.receivables).then(res => {
          loading.clear()
          if (res && res.payReceivablesAppPaymentFormDtoAList) {
            res.payReceivablesAppPaymentFormDtoAList.map(item => {
              const startArr = item.dbegin ? item.dbegin.split(' ') : []
              item.dbegin = startArr.length ? startArr[0] : ''
              const endArr = item.dend ? item.dend.split(' ') : []
              item.dend = endArr.length ? endArr[0] : ''
            })
          }
          this.payData = res || {}
          if (!res) {
            this.status = 1
          }
        }).catch(err => {
          console.log(err)
          loading.clear()
          Toast(err.msg || '出错了，请重试')
        })
      } catch (error) {
        Toast(error.msg || '出错了，请重试')
        console.log(error)
      }
    },
    handlePay () {
      // if (!this.payListData.length) {
      //   Toast('请使用支付宝或者微信扫码支付')
      //   return false
      // }
      if (this.payFlag) return
      let loading = Toast.loading({ duration: 0, message: '支付中...' })
      this.payFlag = true
      NetService.QRCodePay(this.receivables).then(res => {
        if (res.counter_url) {
          this.orderId = res.pay_order_no
          window.location.href = res.counter_url
        } else {
          setTimeout(() => {
            loading.clear()
          }, 1000)
          Toast(res.msg || '出错了，请重试')
          this.payFlag = false
        }
      }).catch(err => {
        console.log(err)
        setTimeout(() => {
          loading.clear()
        }, 1000)
        Toast(err.msg || '出错了，请重试')
        this.payFlag = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: calc(100vh - 130px);
  overflow: auto;
  background: rgb(247, 247, 247);
  &.error {
    height: 100vh;
  }
}
.page-error {
  font-size: 24px;
  text-align: center;
  padding-top: 400px;
}
.page-list {
  margin: 30px;
  .item {
    padding: 0 30px;
    position: relative;
    background: #fff;
    margin-bottom: 30px;
    border-radius: 20px;
    &-header {
      height: 108px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid rgba(245, 245, 245, 1);
      &-left {
        display: flex;
        align-items: center;
        &-icon {
          width: 36px;
          height: 36px;
        }
        &-text {
          margin-left: 10px;
          font-size: 24px;
        }
      }
      &-right {
        display: flex;
        align-items: center;
        &-text {
          margin-right: 10px;
          font-size: 28px;
          font-weight: 500;
          color: rgba(255, 92, 80, 1);
        }
      }
    }
    &-content {
      padding: 26px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-left {
        &-row {
          height: 54px;
          display: flex;
          align-items: center;
          &-text {
            font-size: 22px;
            color: rgba(155, 155, 155, 1)
          }
        }
      }
      &-right {
        &.color-green {
          font-size: 22px;
          color: #49E39A;
        }
        &.color-orange {
          font-size: 22px;
          color: rgba(255, 139, 92, 1);
        }
      }
    }
  }
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 24px;
  border-top: 1px solid rgb(217 216 214 / 17%);
  box-shadow: 0 7px 4px rgba(217 216 214 / 17%);
  background: #fff;
  height: 130px;
  border-radius: 20px 20px 0 0;
  &-top {
    align-items: center;
		justify-content: space-between;
    display: flex;
    padding-top: 20px;
    &-left {
      font-size: 22px;
      .paid-item {
        padding: 10px 0;
      }
    }
    &-right {
      width: 208px;
      height: 64px;
      text-align: center;
      line-height: 64px;
      background: #FF8B5C;
      border-radius: 10px;
      color: #fff;
      font-size: 32px;
      font-weight: 500;
    }
  }
  &-paytype {
    display: flex;
    align-items: center;
    padding: 20px 0;
    &-text {
      font-size: 22px;
    }
    .pay-list{
      display: flex;
      align-items: center;
      flex: 1;
      .item{
        width: 120px;
        height: 42px;
        border-radius: 6px;
        margin-left: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 38px;
        font-size: 20px;
        &.active{
          background: #FF8B5C;
          color: $color-white;
        }
        &-icon{
          width: 22px;
          height: 22px;
          margin: 0 6px 0 0;
        }
      }
    }
  }
}
</style>